export default __webpack_public_path__ + "static/media/N_Laminate.93e29822.jpg";